<template>
    <div class="img-box">
        <div class="img-detail" v-for="item in marketObj" :key="item.id">
            <img :src="item.src">
            <h1>{{item.t1}}</h1>
            <hr align=center width=48px color=#3b97ff SIZE=2 noShade style="margin:0 auto;">
            <h2>{{item.t2}}</h2>
            <h3>{{item.t3}}</h3>
            <h3>{{item.t4}}</h3>
        </div>
    </div>
</template>

<script>
    export default {
        name: "marketIMG",
        data(){
            return{
                marketObj: [
                    {
                        id: 1,
                        src: require('../../assets/xf/meiti.png'),
                        t1: "媒体广告投放",
                        t2: "手机App、EDM",
                        t3: "以精准营销为核心理念",
                        t4: "基于大数据进行定向广告投放"
                    },/* {
                        id: 2,
                        src: require('../../assets/xf/zimeit.png'),
                        t1: "自媒体流量运营转化",
                        t2: "微信、支付宝、头条",
                        t3: "自媒体传播驱动",
                        t4: "保险社群运营"
                    },*/ {
                        id: 3,
                        src: require('../../assets/xf/pinpai.png'),
                        t1: "品牌整合营销",
                        t2: "渠道推广、口碑营销",
                        t3: "渠道拓展运营",
                        t4: "场景解决方案"
                    }, {
                        id: 4,
                        src: require('../../assets/xf/pingtai.png'),
                        t1: "平台电商运营",
                        t2: "各大保险电商平台",
                        t3: "直营平台运营",
                        t4: "营销解决方案"
                    }
                ]
            }
        }
    }
</script>

<style scoped>
    .img-box {
        height: 400px;
        width: 80%;
        display: flex;
        flex-direction: row;
        z-index: 2;
        margin-top: 50px;
        margin-left: 10%;
    }

    .img-detail {
        width: 25%;
        height: 100%;
        margin: auto;
        display: flex;
        flex-direction: column;
    }
    .img-detail img{
        width: 156px;
        height: 156px;
        margin: auto;
    }
    h1 {
        font-family: SourceHanSansCN-Regular;
        font-size: 18px;
        color: #fff;
        text-align: center;
    }
    h2 {
        font-family: SourceHanSansCN-Regular;
        font-size: 14px;
        color: #fff;
        text-align: center;
        opacity: 0.6;
        margin-bottom: 40px;
    }
    h3 {
        font-family: SourceHanSansCN-Regular;
        font-size: 14px;
        color: #fff;
        text-align: center;
        line-height: 18px;
        margin-bottom: 0;
    }
</style>



// WEBPACK FOOTER //
// src/views/components/marketIMG.vue